// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/myAccount/drop-arrow-gray.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.myDocuments_tru-mma-main-wrapper__OulPL {
  background-color: #f5f5f5;
  margin-bottom: 40px;
  padding: 16px;
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75);
  border: 1px solid #ced4da;
  --chevron-size: 6px; /* overall box size */
  --chevron-thickness: 2px; /* line thickness */
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_custom-select__SxUKC {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  height: 40px;
  min-height: 0;
  max-width: 100%;
  padding: 0 50px 0 5px;
  font-size: 14px;
  border: 1px solid #e6e9ee;
  color: #222222;
  font-weight: 300;
  margin-bottom: 15px;
  border-radius: 0;
}
.myDocuments_tru-mma-main-wrapper__OulPL {
  /* Shared base */
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_icon-chevron__C9WZl {
  display: inline-block;
  width: var(--chevron-size);
  height: var(--chevron-size);
  color: inherit; /* uses parent text color */
  vertical-align: middle;
}
.myDocuments_tru-mma-main-wrapper__OulPL {
  /* The actual “V” is a rotated element with borders */
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_icon-chevron__C9WZl::before {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  border-left: var(--chevron-thickness) solid currentColor;
  border-bottom: var(--chevron-thickness) solid currentColor;
  box-sizing: border-box;
  transform-origin: 50% 50%;
  transition: transform 0.2s ease;
}
.myDocuments_tru-mma-main-wrapper__OulPL {
  /* Down chevron (∇) */
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_icon-chevron-down__VOEEp::before {
  transform: rotate(-45deg); /* makes the “V” point down */
}
.myDocuments_tru-mma-main-wrapper__OulPL {
  /* Up chevron (∧) */
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_icon-chevron-up__HFZbu::before {
  transform: rotate(135deg); /* flips to point up */
}
.myDocuments_tru-mma-main-wrapper__OulPL {
  /* Optional: hover animation */
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_icon-chevron__C9WZl:hover::before {
  transform: translateY(1px) rotate(-45deg);
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_icon-chevron-up__HFZbu:hover::before {
  transform: translateY(-1px) rotate(135deg);
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_tru-mma-main-content-box__FkY6M {
  margin-bottom: 30px;
  border: 1px solid #6c757d;
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_tru-mma-main-service-header__2Ubfn {
  font-weight: 300;
  background-color: #73c573;
  line-height: 1.1;
  padding: 10px 16px;
  color: white;
  display: block;
  font-size: 28px;
  text-decoration: none;
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_tru-mma-main-service-box__ZW3qo {
  padding: 16px 0;
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_tru-mma-main-service-box__ZW3qo .myDocuments_column-header__rt3p8 {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_tru-mma-main-service-box__ZW3qo .myDocuments_column-header__rt3p8 .myDocuments_tg-tablestr-cur__EGtlx {
  text-decoration: underline;
}
.myDocuments_tru-mma-main-wrapper__OulPL .myDocuments_tru-mma-main-service-box__ZW3qo .myDocuments_alternate-doc-bg__HBsH9 > div:nth-child(odd) {
  background-color: rgba(28, 28, 28, 0.0509803922);
}`, "",{"version":3,"sources":["webpack://./src/styles/myAccount/myDocuments.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gDAAA;EACA,yBAAA;EACA,mBAAA,EAAA,qBAAA;EACA,wBAAA,EAAA,mBAAA;AAEF;AAAE;EACE,gBAAA;EACA,yDAAA;EACA,yBAAA;EACA,4BAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;AA1BA;EA2BE,gBAAA;AAEF;AADE;EACE,qBAAA;EACA,0BAAA;EACA,2BAAA;EACA,cAAA,EAAA,2BAAA;EACA,sBAAA;AAGJ;AApCA;EAoCE,qDAAA;AAGF;AAFE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,wDAAA;EACA,0DAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;AAIJ;AAlDA;EAiDE,qBAAA;AAIF;AAHE;EACE,yBAAA,EAAA,6BAAA;AAKJ;AAxDA;EAsDE,mBAAA;AAKF;AAJE;EACE,yBAAA,EAAA,sBAAA;AAMJ;AA9DA;EA2DE,8BAAA;AAMF;AALE;EACE,yCAAA;AAOJ;AALE;EACE,0CAAA;AAOJ;AAJE;EACE,mBAAA;EACA,yBAAA;AAMJ;AAHE;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAKJ;AAFE;EACE,eAAA;AAIJ;AAFI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAIN;AAHM;EACE,0BAAA;AAKR;AADM;EACE,gDAAA;AAGR","sourcesContent":[".tru-mma-main-wrapper {\n  background-color: #f5f5f5;\n  margin-bottom: 40px;\n  padding: 16px;\n  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75);\n  border: 1px solid #ced4da;\n  --chevron-size: 6px; /* overall box size */\n  --chevron-thickness: 2px; /* line thickness */\n\n  .custom-select {\n    appearance: none;\n    background-image: url(../../../public/images/myAccount/drop-arrow-gray.png);\n    background-position: 100%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    height: 40px;\n    min-height: 0;\n    max-width: 100%;\n    padding: 0 50px 0 5px;\n    font-size: 14px;\n    border: 1px solid #e6e9ee;\n    color: #222222;\n    font-weight: 300;\n    margin-bottom: 15px;\n    border-radius: 0;\n  }\n\n  /* Shared base */\n  .icon-chevron {\n    display: inline-block;\n    width: var(--chevron-size);\n    height: var(--chevron-size);\n    color: inherit; /* uses parent text color */\n    vertical-align: middle;\n  }\n\n  /* The actual “V” is a rotated element with borders */\n  .icon-chevron::before {\n    content: \"\";\n    display: block;\n    width: 100%;\n    height: 100%;\n    border-left: var(--chevron-thickness) solid currentColor;\n    border-bottom: var(--chevron-thickness) solid currentColor;\n    box-sizing: border-box;\n    transform-origin: 50% 50%;\n    transition: transform 0.2s ease;\n  }\n\n  /* Down chevron (∇) */\n  .icon-chevron-down::before {\n    transform: rotate(-45deg); /* makes the “V” point down */\n  }\n\n  /* Up chevron (∧) */\n  .icon-chevron-up::before {\n    transform: rotate(135deg); /* flips to point up */\n  }\n\n  /* Optional: hover animation */\n  .icon-chevron:hover::before {\n    transform: translateY(1px) rotate(-45deg);\n  }\n  .icon-chevron-up:hover::before {\n    transform: translateY(-1px) rotate(135deg);\n  }\n\n  .tru-mma-main-content-box {\n    margin-bottom: 30px;\n    border: 1px solid #6c757d;\n  }\n\n  .tru-mma-main-service-header {\n    font-weight: 300;\n    background-color: #73c573;\n    line-height: 1.1;\n    padding: 10px 16px;\n    color: white;\n    display: block;\n    font-size: 28px;\n    text-decoration: none;\n  }\n\n  .tru-mma-main-service-box {\n    padding: 16px 0;\n\n    .column-header {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      margin-bottom: 8px;\n      .tg-tablestr-cur {\n        text-decoration: underline;\n      }\n    }\n    .alternate-doc-bg {\n      & > div:nth-child(odd) {\n        background-color: #1c1c1c0d;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tru-mma-main-wrapper": `myDocuments_tru-mma-main-wrapper__OulPL`,
	"custom-select": `myDocuments_custom-select__SxUKC`,
	"icon-chevron": `myDocuments_icon-chevron__C9WZl`,
	"icon-chevron-down": `myDocuments_icon-chevron-down__VOEEp`,
	"icon-chevron-up": `myDocuments_icon-chevron-up__HFZbu`,
	"tru-mma-main-content-box": `myDocuments_tru-mma-main-content-box__FkY6M`,
	"tru-mma-main-service-header": `myDocuments_tru-mma-main-service-header__2Ubfn`,
	"tru-mma-main-service-box": `myDocuments_tru-mma-main-service-box__ZW3qo`,
	"column-header": `myDocuments_column-header__rt3p8`,
	"tg-tablestr-cur": `myDocuments_tg-tablestr-cur__EGtlx`,
	"alternate-doc-bg": `myDocuments_alternate-doc-bg__HBsH9`
};
export default ___CSS_LOADER_EXPORT___;
